var React = require('react');

function Margin (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","opacity":".4","stroke":"#333","strokeMiterlimit":"10","strokeWidth":".86"},[React.createElement("path",{"d":"M26.52 13v-1h-1","key":0}),React.createElement("path",{"d":"M23.47 12H3.94","strokeDasharray":"2.06 2.06","key":1}),React.createElement("path",{"d":"M2.91 12h-1v1","key":2}),React.createElement("path",{"d":"M1.91 14.67v2.5","strokeDasharray":"1.67 1.67","key":3}),React.createElement("path",{"d":"M1.91 18v1h1","key":4}),React.createElement("path",{"d":"M4.96 19h19.53","strokeDasharray":"2.06 2.06","key":5}),React.createElement("path",{"d":"M25.52 19h1v-1","key":6}),React.createElement("path",{"d":"M26.52 16.33v-2.5","strokeDasharray":"1.67 1.67","key":7}),React.createElement("path",{"d":"M1.48 1h25.11M1.41 4.5h21.54M1.41 8h25.11","key":8})]));
}

Margin.defaultProps = {"id":"Layer_1","viewBox":"0 0 28 20"};

module.exports = Margin;

Margin.default = Margin;
